import React, { useEffect } from "react";
import stock from "../assets/Homepage - StocksPhoto.png";
import AI from "../assets/AI.jpeg";
import edu from "../assets/EDU-Dashboard.png";
import "./HomepageStuff.css";

const HomepageStuff = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1, // Element should be 10% in view to trigger
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in");
        }
      });
    };

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );

    // Select all elements you want to animate
    const elementsToAnimate = document.querySelectorAll(".fade-in-element");
    elementsToAnimate.forEach((element) => observer.observe(element));

    return () => {
      // Clean up the observer
      elementsToAnimate.forEach((element) => observer.unobserve(element));
    };
  }, []);

  return (
    <>
      <div className="insight-container">
        <div className="insight-content">
          <div className="insight-flex">
            {/* Text Content */}
            <div className="insight-text fade-in-element">
              <h1 className="insight-heading">
                Real-time insights, Customizable portfolios, and tools to help
                you make smarter financial decisions.
              </h1>
              <h2 className="insight-subheading fade-in-element">
                From real-time market updates to personalized portfolio
                management, Quantiq's tools are built to help you make informed
                and confident financial decisions.
              </h2>
            </div>

            {/* Image Container */}
            <div className="insight-image-container fade-in-element">
              <img
                src={stock}
                alt="Financial tools illustration"
                className="insight-image fade-in-element"
              />
            </div>
          </div>
        </div>
        <div className="AI-container">
          <div className="AI-content">
            <div className="AI-flex">
              {/* Text Content */}
              <div className="AI-text fade-in-element">
                <h1 className="AI-heading">
                  Smart AI Insights: Your Financial Companion
                </h1>
                <h2 className="AI-subheading fade-in-element">
                  Receive on-the-go guidance with AI-powered tools designed to
                  demystify market shifts and help you make informed
                  decisions—right when you need it
                </h2>
              </div>

              {/* Image Container */}
              <div className="AI-image-container fade-in-element">
                <img
                  src={AI}
                  alt="AI illustration"
                  className="AI-image fade-in-element"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="edu-container">
        <div className="edu-content">
          <div className="edu-flex">
            {/* Text Content */}
            <div className="edu-text fade-in-element">
              <h1 className="edu-heading">
                Investment Education and Guidance
              </h1>
              <h2 className="edu-subheading fade-in-element">
              Grow Your Financial Knowledge with Personalized Learning Paths, 
              Clear Explanations, and Interactive Tools to Build Confidence in 
              Every Investment Decision.
              </h2>
            </div>

            {/* Image Container */}
            <div className="edu-image-container fade-in-element">
              <img
                src={edu}
                alt="educational tools illustration"
                className="edu-image fade-in-element"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomepageStuff;
